// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.PopoverContainer.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * PopoverContainer component
 */
import React from 'react';
import { observer } from 'mobx-react';
import constants from 'logic/data/Izenda.CalculatedFieldConstants';
import { Popover } from 'share/components/controls/Izenda.Popover';
import ExpressionSelection from 'share/components/controls/calculatedField/Izenda.ExpressionSelection';

@observer
class PopoverContainer extends React.Component {
  static displayName = 'PopoverContainer';

  /**
   * Handle on update expression
   * @param {String} name
   */
  updateCalculatedExpression = (name: String) => {
    let {
      expressionSelectionUI: { cursorPosition: cursorPos },
      store: { clonedModel: calculatedModel },
      sourceId
    } = this.props;

    if (calculatedModel) {
      let expression = calculatedModel.expression;
      const textBefore = expression.substring(0, cursorPos);
      const textAfter = expression.substring(cursorPos, expression.length);
      calculatedModel.expression = textBefore + name + textAfter;
    }
    // Focus on Calculate Expression
    $izenda(`#${sourceId}`).focus();
  };

  render() {
    let {
      expressionSelectionUI: { visible, left, top },
      store: { expressionSelection },
      type: popupType,
      expressionConfig,
      displayExpressionSelection
    } = this.props;
    const displayDataSource =
      popupType.title !== constants.TYPES.GRAND_TOTAL.title &&
      popupType.title !== constants.TYPES.SUB_TOTAL.title;
    return (
      <Popover visible={visible} positionLeft={left} positionTop={top}>
        <ExpressionSelection
          store={expressionSelection}
          updateValue={this.updateCalculatedExpression}
          expressionConfig={expressionConfig}
          displayExpressionSelection={displayExpressionSelection}
          displayDataSource={displayDataSource}
        />
      </Popover>
    );
  }
}

export default PopoverContainer;



// WEBPACK FOOTER //
// ./ui/share/components/controls/calculatedField/Izenda.PopoverContainer.js